import { Dayjs } from 'dayjs';

const getSortedDates = (v: [Dayjs | null, Dayjs | null]) => {
  // Sort the dates to ensure startDate <= endDate
  return v.filter(Boolean).sort((a, b) => {
    if (!a || !b) return 0; // This should never happen due to filter(Boolean)
    return a.diff(b);
  });
};

export default getSortedDates;
